// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.layered {
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.layered-no-overlap {
  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.no-gutter > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.manage-alarms {
  display: flex;
  flex-flow: column;
  align-items: center;
}
.manage-alarms .alarm-list {
  align-self: stretch;
}
.manage-alarms .alarm-list .alarm-row {
  display: grid;
  grid-template-columns: 2rem 1fr 2rem;
  align-items: center;
  gap: 1rem;
  position: relative;
}
.manage-alarms .alarm-list .alarm-row.all-day {
  grid-template-columns: 2rem 1fr 4.5rem 2rem;
}
.manage-alarms .alarm-list .alarm-row > .form-group > input {
  height: 2.3rem;
}
.manage-alarms .alarm-list .alarm-row .remove-btn {
  text-align: center;
  cursor: pointer;
  color: #696969;
}
.manage-alarms .alarm-list .alarm-row .Select-menu-outer {
  position: absolute;
  transform: translateY(-100%);
}
.manage-alarms .alarm-list .alarm-row + .alarm-row {
  margin-top: 0.5rem;
}
.manage-alarms .new-alarm-btn {
  margin-top: 1rem;
}
.manage-alarms .minimal-input {
  padding-left: 0;
  padding-right: 0;
  padding: 0;
  height: auto;
}
.manage-alarms .form-control {
  color: #292727;
}
.manage-alarms .form-group {
  margin: 0;
}
.manage-alarms .btn-default {
  min-width: 12rem;
  border: 0;
  background: 0;
  border-radius: 0;
  color: #696969;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/ManageAlarms/ManageAlarms.scss","webpack://./src/Styles/Material.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;ACFA;EACE,gFAAA;ADKF;;ACFA;EACE,gFAAA;ADKF;;ACFA;EACE,gBAAA;EACA,eAAA;ADKF;;AAXA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;AAcF;AAZE;EACE,mBAAA;AAcJ;AAZI;EACE,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAcN;AAZM;EACE,2CAAA;AAcR;AAXM;EACE,cAAA;AAaR;AAVM;EACE,kBAAA;EACA,eAAA;EACA,cD3BQ;ACuChB;AATM;EACE,kBAAA;EACA,4BAAA;AAWR;AAPM;EACE,kBAAA;AASR;AAJE;EACE,gBAAA;AAMJ;AAHE;EACE,eAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;AAKJ;AAFE;EACE,cDvDQ;AC2DZ;AADE;EACE,SAAA;AAGJ;AAAE;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,cDlEY;ACoEhB","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import 'Variables.scss';\n@import 'Colors.scss';\n@import 'Material.scss';\n\n.manage-alarms {\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n\n  .alarm-list {\n    align-self: stretch;\n\n    .alarm-row {\n      display: grid;\n      grid-template-columns: 2rem 1fr 2rem;\n      align-items: center;\n      gap: 1rem;\n      position: relative;\n\n      &.all-day {\n        grid-template-columns: 2rem 1fr 4.5rem 2rem;\n      }\n\n      & > .form-group > input {\n        height: 2.3rem;\n      }\n\n      .remove-btn {\n        text-align: center;\n        cursor: pointer;\n        color: $darkTextColor;\n      }\n\n      .Select-menu-outer {\n        position: absolute;\n        transform: translateY(-100%);\n        // z-index: 1;\n      }\n\n      & + .alarm-row {\n        margin-top: 0.5rem;\n      }\n    }\n  }\n\n  .new-alarm-btn {\n    margin-top: 1rem;\n  }\n\n  .minimal-input {\n    padding-left: 0;\n    padding-right: 0;\n    padding: 0;\n    height: auto;\n  }\n\n  .form-control {\n    color: $textColor;\n  }\n\n  .form-group {\n    margin: 0;\n  }\n\n  .btn-default {\n    min-width: 12rem;\n    border: 0;\n    background: 0;\n    border-radius: 0;\n    color: $darkTextColor;\n  }\n}\n",".layered {\n  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.layered-no-overlap {\n  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.no-gutter > [class*='col-'] {\n  padding-right: 0;\n  padding-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
